import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setDesignOptionsEnabledReducer = (state: VariantsState, action: PayloadAction<boolean>) => {
  state.designOptionsEnabled = action.payload;
};

export default setDesignOptionsEnabledReducer;
